import { useFormik } from 'formik';
import { initialValues } from './formData';
import { validationSchema } from './formData';
import { SingleDynamicField } from '../../../../../shared/types/assistant';
import { useEffect } from 'react';
import {
    ChatAssistant,
    InitialConfiguration,
} from '../../../../../shared/types/chat-assistant';

interface SmartResponseFormatForm {
    [key: string]: SingleDynamicField[];
}

export const useSmartResponseFormat = (chatAssistant: ChatAssistant) => {
    const formikSmartResponseFormat = useFormik<SmartResponseFormatForm>({
        initialValues,
        validationSchema,
        onSubmit: console.log,
    });

    useEffect(() => {
        if (chatAssistant) {
            formikSmartResponseFormat.setValues({
                smartResponseFormat:
                    (
                        chatAssistant?.initialConfiguration as InitialConfiguration
                    )?.smartResponseFormat ?? initialValues.smartResponseFormat,
            });
        }
    }, [chatAssistant]);

    return { formikSmartResponseFormat };
};
